export default function ExperienceSection() {
  const achievements = [
    { icon: 'ri-award-line', title: '40+ Patents', desc: 'Inventor and co-inventor on over 40 technology patents spanning AI, networking, and cloud infrastructure.' },
    { icon: 'ri-team-line', title: '75+ Engineers Led', desc: 'Built and managed high-performing engineering teams across multiple product lines and geographies.' },
    { icon: 'ri-line-chart-line', title: '$2B+ Revenue', desc: 'Directly contributed to products and initiatives generating over $2 billion in revenue at Cisco.' },
    { icon: 'ri-global-line', title: 'Global Impact', desc: 'Deployed solutions used by Fortune 500 companies and government agencies worldwide.' },
    { icon: 'ri-cpu-line', title: 'AI Pioneer', desc: 'Early adopter and implementer of machine learning and AI solutions in enterprise networking.' },
    { icon: 'ri-rocket-line', title: 'Product Launches', desc: 'Led end-to-end product development from concept to market for multiple industry-defining products.' },
  ];

  const techTags = [
    'Artificial Intelligence', 'Machine Learning', 'Natural Language Processing',
    'Voice AI', 'Cisco Systems', 'Enterprise Networking', 'Cloud Architecture',
    'Python', 'TensorFlow', 'LLMs', 'OpenAI', 'Product Strategy',
    'Team Leadership', 'Patent Development', 'Digital Transformation',
  ];

  return (
    <section id="experience" className="py-24 px-6 lg:px-12 bg-gray-950 text-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-teal-500/20 text-teal-400 text-sm font-semibold rounded-full mb-4 tracking-wide uppercase">
            Experience
          </span>
          <h2 className="font-['Playfair_Display'] text-4xl lg:text-5xl font-bold text-white mb-4">
            25+ Years at the Forefront of Innovation
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Distinguished careers at Cisco Systems, leading breakthrough technology initiatives that shaped the modern enterprise and VOIP.
          </p>
          <div className="w-16 h-1 bg-teal-500 mx-auto rounded-full mt-6"></div>
        </div>

        {/* Cisco Banner */}
        <div className="relative rounded-2xl overflow-hidden mb-16 bg-gradient-to-r from-gray-800 to-gray-900 border border-gray-700">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://public.readdy.ai/ai/img_res/5ac729c22b36f4df616dfc338e285ab2.jpg"
              alt="Cisco Background"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative z-10 p-10 flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-500/20 rounded-xl">
                  <i className="ri-building-line text-teal-400 text-2xl"></i>
                </div>
                <div>
                  <div className="text-white font-bold text-xl">Cisco Systems</div>
                  <div className="text-gray-400 text-sm">Senior Technology Executive · 15+ Years</div>
                </div>
              </div>
              <p className="text-gray-300 leading-relaxed max-w-2xl">
                Peter spent over 15 years at Cisco Systems, one of the world's leading technology companies, where he rose through the ranks to become a senior technology leader. His telephony research, enterprise networking, cloud infrastructure, and product innovation — leaving a lasting impact on the company's most strategic initiatives.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4 flex-shrink-0">
              {[
                { value: '15+', label: 'Years' },
                { value: '40+', label: 'Patents' },
                { value: '75+', label: 'Engineers' },
                { value: '$2B+', label: 'Revenue' },
              ].map((s) => (
                <div key={s.label} className="text-center bg-white/5 rounded-xl p-4 border border-white/10">
                  <div className="text-3xl font-bold text-teal-400">{s.value}</div>
                  <div className="text-gray-400 text-sm mt-1">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Achievement Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {achievements.map((a) => (
            <div key={a.title} className="bg-gray-800/50 rounded-xl p-6 border border-gray-700 hover:border-teal-500/50 transition-all duration-200 hover:-translate-y-1">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-500/20 rounded-xl mb-4">
                <i className={`${a.icon} text-teal-400 text-2xl`}></i>
              </div>
              <h4 className="text-white font-bold text-lg mb-2">{a.title}</h4>
              <p className="text-gray-400 text-sm leading-relaxed">{a.desc}</p>
            </div>
          ))}
        </div>

        {/* Tech Tags */}
        <div className="text-center">
          <h3 className="text-white font-semibold text-lg mb-6">Technologies &amp; Expertise</h3>
          <div className="flex flex-wrap justify-center gap-3">
            {techTags.map((tag) => (
              <span key={tag} className="px-4 py-2 bg-gray-800 text-gray-300 text-sm rounded-full border border-gray-700 hover:border-teal-500/50 hover:text-teal-400 transition-colors duration-200 cursor-default">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
